@if ({
  qty: qty$ | async,
  }; as content) {
  {{ content.qty }}
}
